// extracted by mini-css-extract-plugin
export default {"content":"Content_content__qsWw5","fadeIn":"Content_fadeIn__-bflA","content__title":"Content_content__title__nnwBC","content__msg":"Content_content__msg__70S3U"};